"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = KeyEmployeeRefineModal;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _KeyEmployeeModalFormControls = require("./KeyEmployeeModalFormControls");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function KeyEmployeeRefineModal(props) {
  var {
    handleClose,
    snapshot,
    show
  } = props;

  // Pulling formik context from higher up, which gives us access to formik state
  var {
    errors,
    touched,
    setFieldValue,
    values,
    isSubmitting,
    isValid
  } = (0, _formik.useFormikContext)();
  var handleSubmit = e => {
    e.preventDefault();
    handleClose();
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "lg",
    show: show
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(snapshot),
    title: "Edit your inputs & our assumptions"
  }), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-6 col-sm-12"
  }, /*#__PURE__*/_react.default.createElement("h3", null, "Key Employees"), /*#__PURE__*/_react.default.createElement(_formik.FieldArray, {
    name: "employees"
  }, fieldArrayProps => {
    var {
      form,
      push,
      remove
    } = fieldArrayProps;
    var {
      values
    } = form;
    var {
      employees
    } = values;
    var maxEmployees = employees.length >= 5;
    var returnArray = [];
    var addOnClick = () => {
      // Push info relevant to employee - employee's name, annual profit attributable to employee, and years needed to fully replace employee
      push({
        employeeId: '',
        annualProfitAttributable: '',
        replaceEmployeeYears: ''
      });
    };
    employees.forEach((employee, i) => {
      var isFirstEmployee = i == 0;
      var removeOnClick = () => {
        remove(i);
      };
      returnArray.push(/*#__PURE__*/_react.default.createElement(_react.Fragment, {
        key: i
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "align-items-center"
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: "flex-grow-by-1"
      }, "Employee ".concat(i + 1)), !isFirstEmployee && /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(RemoveButton, {
        onClick: removeOnClick
      }))), /*#__PURE__*/_react.default.createElement(_KeyEmployeeModalFormControls.EmployeeIdentity, {
        i: i,
        values: values,
        errors: errors,
        touched: touched
      }), /*#__PURE__*/_react.default.createElement(_KeyEmployeeModalFormControls.AnnualProfitAttributable, {
        i: i,
        values: values,
        errors: errors,
        touched: touched
      }), /*#__PURE__*/_react.default.createElement(_KeyEmployeeModalFormControls.ReplaceEmployeeYears, {
        i: i,
        values: values,
        errors: errors,
        touched: touched
      })));
    });
    if (!maxEmployees) {
      returnArray.push(/*#__PURE__*/_react.default.createElement(AddButton, {
        key: "add",
        onClick: addOnClick
      }));
    }
    return returnArray;
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-6 col-sm-12"
  }, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("h3", null, "Other Details"), /*#__PURE__*/_react.default.createElement(_KeyEmployeeModalFormControls.GrossProfit, {
    values: values,
    errors: errors,
    touched: touched
  }), /*#__PURE__*/_react.default.createElement(_KeyEmployeeModalFormControls.ShortTermAssets, {
    values: values,
    errors: errors,
    touched: touched
  }), /*#__PURE__*/_react.default.createElement(_KeyEmployeeModalFormControls.IndustrySector, {
    values: values,
    errors: errors,
    touched: touched,
    setFieldValue: setFieldValue
  }))))), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Footer, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
    variant: "link",
    onClick: () => handleClose(snapshot)
  }, "Cancel"), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
    disabled: isSubmitting || !isValid,
    onClick: handleSubmit
  }, "Update"))));
}
var RemoveButton = _ref => {
  var {
    onClick
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
    variant: "inline",
    className: "btn-inline remove-button",
    onClick: onClick,
    style: {
      alignSelf: 'center'
    }
  }, "Remove ", /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-answer-incorrect"
  }));
};
var AddButton = _ref2 => {
  var {
    onClick
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
    variant: "inline",
    className: "btn-inline",
    onClick: onClick,
    id: "keyemployee_addEmployeeBtn"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-add"
  }), " Add Another Employee");
};